<template>
  <div
    id="app"
    class="h-100"
    :class="[skinClasses]"
  >
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
import { $themeColors, $themeBreakpoints, $themeConfig } from '@themeConfig'
import { provideToast } from 'vue-toastification/composition'
import { watch } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'

import { useWindowSize, useCssVar } from '@vueuse/core'

import store from '@/store'

const LayoutVertical = () => import('@/layouts/vertical/LayoutVertical.vue')
const LayoutHorizontal = () => import('@/layouts/horizontal/LayoutHorizontal.vue')
const LayoutFull = () => import('@/layouts/full/LayoutFull.vue')
import useJwt from "@/auth/jwt/useJwt";
import { localize } from 'vee-validate'
import { mapActions, mapGetters, mapState } from "vuex";


export default {
  components: {
    // Layouts
    LayoutHorizontal,
    LayoutVertical,
    LayoutFull,
  },
  computed: {
    layout() {
      if (this.$route.meta.layout === 'full') return 'layout-full'
      return `layout-${this.contentLayoutType}`
    },
    contentLayoutType() {
      return this.$store.state.appConfig.layout.type
    },
  },
  methods: {
    ...mapActions('app', ['FETCH_ALL_NOTIFICATIONS', 'FETCH_NOTIFICATIONS_SET_NOTIF']),
  },
  beforeCreate() {
    // Set colors in theme
    const colors = [
      'primary',
      'secondary',
      'success',
      'info',
      'warning',
      'danger',
      'light',
      'dark',
    ]

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = colors.length; i < len; i++) {
      $themeColors[colors[i]] = useCssVar(
        `--${colors[i]}`,
        document.documentElement,
      ).value.trim()
    }

    // Set Theme Breakpoints
    const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl']

    // eslint-disable-next-line no-plusplus
    for (let i = 0, len = breakpoints.length; i < len; i++) {
      $themeBreakpoints[breakpoints[i]] = parseFloat(
        useCssVar(
          `--breakpoint-${breakpoints[i]}`,
          document.documentElement,
        ).value.slice(0, -2),
      )
    }

    // Set RTL
    const { isRTL } = $themeConfig.layout
    document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr')
  },

  created() {
    const user_data = useJwt.getUserData();

    if(localStorage.getItem('lang')){
      this.$i18n.locale = localStorage.getItem('lang');
    }else if (user_data && user_data.language){
      this.$i18n.locale = user_data.language;
    }else{
      this.$i18n.locale = 'ru'
    }
    localize(this.$i18n.locale);
    localStorage.setItem('lang', this.$i18n.locale);
  },
  async mounted(){
    // await this.$connect()

    // setTimeout(() => {
    //   this.$options.sockets.onmessage = (data) => {
    //     let a  = JSON.parse(data.data)
    //     console.log(a)
    //     if(a && a.action && a.action == 'new_notification'){
    //       this.FETCH_ALL_NOTIFICATIONS({is_read: false});
    //       this.$_warningToast(a.message);
    //     }
    //   }
    // }, 1500)

    // this.$disconnect()
  },
  beforeDestroy() {
    // this.$socket.close()
  },
  setup() {
    const { skin, skinClasses } = useAppConfig()

    // If skin is dark when initialized => Add class to body
    if (skin.value === 'dark') document.body.classList.add('dark-layout')

    // Provide toast for Composition API usage
    // This for those apps/components which uses composition API
    // Demos will still use Options API for ease
    provideToast({
      hideProgressBar: true,
      closeOnClick: false,
      closeButton: false,
      icon: false,
      timeout: 3000,
      transition: 'Vue-Toastification__fade',
    })

    // Set Window Width in store
    store.commit('app/UPDATE_WINDOW_WIDTH', window.innerWidth)
    const { width: windowWidth } = useWindowSize()
    watch(windowWidth, val => {
      store.commit('app/UPDATE_WINDOW_WIDTH', val)
    })

    return {
      skinClasses,
    }
  },
}
</script>

<style lang="scss">
.dark-layout #user-table .tableRowClass {
  background: #19213a !important;
}

.dark-layout #radio-group-1 span{
  color: white !important;
}

</style>
